import axios from 'axios';

const eventsModule = {
  actions: {
    async getEvents() {
      const response = await axios.get('/events');
      return response.data.data;
    },
    async getEvent(store, payload) {
      const response = await axios.get(`/events/${payload.eventId}`);
      return response.data.data;
    },
    async createEvent(store, payload) {
      const response = await axios.post('/events/', payload);
      return response.data.data;
    },
    async updateEvent(store, payload) {
      const response = await axios.put(`/events/${payload.eventId}`, payload);
      return response.data.data;
    },
    async joinEvent(store, payload) {
      const response = await axios.post(`/events/${payload.eventId}/join`);
      return response.data.data;
    },
    async createInvite(store, payload) {
      const response = await axios.post(`/events/${payload.eventId}/invites`, {
        userId: payload.userId,
      });
      return response.data.data;
    },
    async removeInvite(store, payload) {
      const response = await axios.post(`/events/${payload.eventId}/invites/${payload.inviteId}`);
      return response.data.data;
    },
  },
};

const invitesModule = {
  actions: {
    async getInvites() {
      const response = await axios.get('/invites');
      return response.data.data;
    },
    async acceptInvite(store, payload) {
      const response = await axios.post(`/invites/${payload.inviteId}/accept`);
      return response.data.data;
    },
    async rejectInvite(store, payload) {
      const response = await axios.post(`/invites/${payload.inviteId}/reject`);
      return response.data.data;
    },
  },
};

const usersModule = {
  actions: {
    async register(store, payload) {
      const response = await axios.post('/register', payload);
      return response.data.data;
    },
    async login(store, payload) {
      const response = await axios.post('/login', payload);
      return response.data.data;
    },
    async me() {
      const response = await axios.get('/me');
      return response.data.data;
    },
  },
};

const integrationsModule = {
  actions: {
    async getIntegrations(store) {
      const response = await axios.get('/integrations');
      const integrations = response.data.data;

      store.commit('setIntegrations', { integrations });

      return integrations;
    },
  },
};

const webhooksModule = {
  actions: {
    async getWebhooks() {
      const response = await axios.get('/webhooks');
      return response.data.data;
    },
  },
};

export default {
  eventsModule,
  invitesModule,
  usersModule,
  integrationsModule,
  webhooksModule,
};



// WEBPACK FOOTER //
// ./src/store/modules.js